(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios')) :
	typeof define === 'function' && define.amd ? define(['exports', 'axios'], factory) :
	(factory((global.CNRequest = {}),global.axios));
}(this, (function (exports,axios) { 'use strict';

axios = axios && axios.hasOwnProperty('default') ? axios['default'] : axios;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */



var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function isUndefined(val) {
    return typeof val === "undefined";
}
function mergeReportData(data1, data2) {
    var extend = undefined;
    if (data1.extend instanceof Object) {
        if (data2.extend instanceof Object) {
            extend = __assign({}, data1.extend, data2.extend);
        }
    }
    else {
        if (data2.extend instanceof Object) {
            extend = data2.extend;
        }
    }
    var reportData = __assign({}, data1, data2, { extend: extend });
    return reportData;
}
function armsTraceLog(response, armsTrace, cnReportData) {
    var _a = response.request, request = _a === void 0 ? {} : _a, _b = response.config, config = _b === void 0 ? {} : _b;
    var currentTime = new Date();
    var errorCode = cnReportData.errorCode, errorMsg = cnReportData.errorMsg, extend = cnReportData.extend, reportResponse = cnReportData.reportResponse;
    var recordInfo = request.__recordInfo__;
    if (!recordInfo) {
        recordInfo = {
            startTime: "-",
        };
    }
    var responseStr = "-";
    if (reportResponse === true) {
        responseStr = JSON.stringify(response);
    }
    var extendStr = "-";
    if (extend) {
        extendStr = JSON.stringify(extend);
    }
    armsTrace.logApi({
        success: false,
        url: config.url,
        httpCode: request.status,
        time: recordInfo.startTime === "-"
            ? "-"
            : currentTime.getTime() - recordInfo.startTime,
        requestType: "XHR",
        method: config.method,
        params: JSON.stringify(config.data),
        header: JSON.stringify(config.headers),
        response: responseStr,
        code: errorCode,
        msg: errorMsg,
        c1: "cn-request-auto",
        c2: extendStr,
    });
}

var LEGAL_METHODS = ["GET", "POST"];
var _window = window;
_window.__cn_request_config = _window.__cn_request_config || {
    cnOptions: {
        armsTrace: null,
    },
    axiosConfig: {},
};
_window.__cn_request_instance =
    _window.__cn_request_instance ||
        {
            request: null,
            reInit: function (config) {
                var _a = config.cnOptions, cnOptions = _a === void 0 ? {} : _a, _b = config.axiosConfig, axiosConfig = _b === void 0 ? {} : _b, _c = config.reset, reset = _c === void 0 ? false : _c;
                if (reset) {
                    _window.__cn_request_config.cnOptions = cnOptions;
                    _window.__cn_request_config.axiosConfig = axiosConfig;
                }
                else {
                    _window.__cn_request_config.cnOptions = __assign({}, _window.__cn_request_config.cnOptions, cnOptions);
                    _window.__cn_request_config.axiosConfig = __assign({}, _window.__cn_request_config.axiosConfig, axiosConfig);
                }
                var axiosInstance = CNRequest(_window.__cn_request_config.axiosConfig, _window.__cn_request_config.cnOptions);
                _window.__cn_request_instance.request = axiosInstance;
                return axiosInstance;
            },
        };
function cnResponseInterceptor(response, armsTrace, options) {
    if (armsTrace === void 0) { armsTrace = null; }
    var _a = options.turnOffTrace, turnOffTrace = _a === void 0 ? false : _a, _b = options.turnOffLog, turnOffLog = _b === void 0 ? false : _b, _c = options.reportResponse, reportResponse = _c === void 0 ? false : _c, _d = options.cnReportHandler, cnReportHandler = _d === void 0 ? function (data) {
        return false;
    } : _d;
    var _e = response.data, success = _e.success, msg = _e.msg, errorMsg = _e.errorMsg, errorCode = _e.errorCode, data = _e.data;
    if (!turnOffLog) {
        if (isUndefined(success) ||
            isUndefined(msg) ||
            isUndefined(errorMsg) ||
            isUndefined(errorCode) ||
            isUndefined(data)) {
            console.warn("\u63A5\u53E3\u8FD4\u56DE\u503C\u683C\u5F0F\u4E0D\u5408\u6CD5: " + response.request.responseURL);
            console.warn("Evil response.data:", response.data);
            console.warn("返回值格式规范请参照: https://yuque.antfin.com/docs/share/18c289e7-7cc9-46d5-aa31-891d18ba168c");
        }
    }
    var doReport = false;
    var reportData = {
        errorCode: "-",
        errorMsg: "-",
        extend: undefined,
        reportResponse: reportResponse,
    };
    if (success === false) {
        doReport = true;
        reportData.errorCode = errorCode ? errorCode : "-";
        reportData.errorMsg = errorMsg ? errorMsg : "-";
    }
    try {
        if (cnReportHandler instanceof Function) {
            var _reportData1 = cnReportHandler(response.data);
            if (_reportData1 instanceof Object) {
                doReport = true;
                reportData = mergeReportData(reportData, _reportData1);
            }
        }
    }
    catch (error) { }
    try {
        var _cnReportHandler = response.config.cnReportHandler;
        if (_cnReportHandler instanceof Function) {
            var _reportData2 = _cnReportHandler(response.data);
            if (_reportData2 instanceof Object) {
                doReport = true;
                reportData = mergeReportData(reportData, _reportData2);
            }
        }
    }
    catch (error) { }
    if (!turnOffTrace && doReport === true && armsTrace) {
        armsTraceLog(response, armsTrace, reportData);
    }
}
function cnRequestInterceptor(config, armsTrace, options) {
    if (armsTrace === void 0) { armsTrace = null; }
    var method = config.method.toUpperCase();
    var _a = options.turnOffLog, turnOffLog = _a === void 0 ? false : _a;
    if (!turnOffLog) {
        if (!LEGAL_METHODS.includes(method)) {
            console.warn("\u4F7F\u7528\u4E86\u4E0D\u88AB\u63A8\u8350\u7684\u8BF7\u6C42method\uFF1A" + method + "\uFF1B\u4EC5\u63A8\u8350 GET \u548C POST \u4E24\u79CD\u8BF7\u6C42method");
        }
    }
}
function CNRequest(axiosConfig, cnOptions) {
    if (axiosConfig === void 0) { axiosConfig = {}; }
    var _a = cnOptions.armsTrace, armsTrace = _a === void 0 ? null : _a, _b = cnOptions.loginCallback, loginCallback = _b === void 0 ? function () { } : _b, _c = cnOptions.turnOffTrace, turnOffTrace = _c === void 0 ? false : _c, _d = cnOptions.turnOffLog, turnOffLog = _d === void 0 ? false : _d, _e = cnOptions.reportResponse, reportResponse = _e === void 0 ? false : _e, _f = cnOptions.cnReportHandler, cnReportHandler = _f === void 0 ? function (data) {
        return false;
    } : _f, _g = cnOptions.noGlobal;
    var logOptions = {
        turnOffTrace: turnOffTrace,
        turnOffLog: turnOffLog,
        reportResponse: reportResponse,
        cnReportHandler: cnReportHandler,
    };
    var axiosInstance = axios.create(axiosConfig);
    axiosInstance.interceptors.request.use(function (config) {
        try {
            cnRequestInterceptor(config, armsTrace, logOptions);
        }
        catch (err) {
            console.error("cnRequestInterceptor\u51FA\u9519:", err);
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    axiosInstance.interceptors.response.use(function (response) {
        var _a = (response.data || {}).errorCode, errorCode = _a === void 0 ? "" : _a;
        try {
            cnResponseInterceptor(response, armsTrace, logOptions);
        }
        catch (err) {
            console.error("cnResponseInterceptor\u51FA\u9519:", err);
        }
        if (errorCode === "1000") {
            try {
                loginCallback();
            }
            catch (error) { }
        }
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
    return axiosInstance;
}
function request(options) {
    if (!_window.__cn_request_instance.request) {
        var axiosInstance = CNRequest(_window.__cn_request_config.axiosConfig, _window.__cn_request_config.cnOptions);
        axiosInstance.interceptors.response.use(function (response) {
            var _a = (response.data || {}).success, success = _a === void 0 ? undefined : _a;
            if (success === true) {
                return response;
            }
            else {
                console.error("business error", response);
                return Promise.reject(response);
            }
        }, function (err) {
            console.error("network error", err);
            return Promise.reject(err);
        });
        _window.__cn_request_instance.request = axiosInstance;
    }
    return _window.__cn_request_instance.request(options);
}
function getRequest() {
    return _window.__cn_request_instance.request;
}
var cnRequestInstance = _window.__cn_request_instance;
var CancelToken = axios.CancelToken;

exports.CancelToken = CancelToken;
exports.cnResponseInterceptor = cnResponseInterceptor;
exports.cnRequestInterceptor = cnRequestInterceptor;
exports.cnRequestInstance = cnRequestInstance;
exports.request = request;
exports.getRequest = getRequest;
exports['default'] = CNRequest;

Object.defineProperty(exports, '__esModule', { value: true });

})));
